import { Route, UrlMatcher, UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';

export function matcher(root: string[], pathOffset = 0): UrlMatcher {
    return (segments: UrlSegment[], group: UrlSegmentGroup, route: Route): UrlMatchResult | null => {
        const paths: string[] = segments.map(segment => segment.path);
        if (paths?.length >= root?.length && root.every((p, index) => p == paths[index])) {
            return {
                consumed: segments,
                posParams: {
                    page: new UrlSegment(paths.length > 0 ? paths[0] : '', {}),
                    path: new UrlSegment(paths.slice(root.length + pathOffset).join('/'), {})
                }
            };
        }
        return null;
    }
}

export const mediaMatcher: UrlMatcher = matcher(['media']);
export const infoMatcher: UrlMatcher = matcher(['info']);
export const policyMatcher: UrlMatcher = matcher(['policy']);

// export function mediaMatcher(): UrlMatcher {
//   return matcher(['media']);
// }

// export function infoMatcher(): UrlMatcher {
//   return matcher(['info']);
// }

// export function policyMatcher(): UrlMatcher {
//   return matcher(['policy']);
// }